import styled from 'styled-components';

export const Form = styled.form`
  margin: 20px 0;
`;
